import React, { useEffect, useState } from 'react';

import BaseSelect from '../../components/BaseSelect';

import './index.css';

import { validate } from '../../utils/formValidation';

const generateFormValues = formData => {
  return formData.reduce((res, data) => {
    return {
      ...res, 
      [data.name]: ''
    }
  }, {})
}

const generateFormErrors = formData => {
  return formData.reduce((res, data) => {
    return {
      ...res, 
      [data.name]: ''
    }
  }, {})
}

const generateInputRules = formData => {
  return formData.reduce((res, data) => {
    return {
      ...res,
      [data.name]: data.validation
    }
  }, {})
}

const BaseFormWithAction = (props) => {
  const [formValues, setFormValues] = useState(generateFormValues(props.formData));
  const [formErrors, setFormErrors] = useState(generateFormErrors(props.formData))
  const inputRules = generateInputRules(props.formData);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    for (let error of Object.values(formErrors)) {
      if (error) {
        return setDisabled(true);
      }
    }
    for (let value of Object.values(formValues)) {
      if (!value) {
        return setDisabled(true);
      }
    }
    setDisabled(false);
  }, [formValues, formErrors])

  const updateField = (e) => {
    //Synthetic event pooling.
    const inputName = e.target.name;
    const inputValue = e.target.value;

    setFormValues({
      ...formValues,
      [inputName]: inputValue
    });
    setFormErrors({
      ...formErrors,
      [inputName]: ''
    })
  }

  const validateField = (inputName, inputValue, input) => {
    let isError = false;
    try {
      validate(inputValue, inputRules[inputName], input.labelName);
      setFormErrors({
        ...formErrors,
        [inputName]: ''
      })
    } catch (error) {
      isError = true;
      setFormErrors({
        ...formErrors,
        [inputName]: error.message
      })
    } finally {
      return isError;
    }
  }

  const checkForm = () => {
    let isError = false;
    props.formData.forEach(input => {
      if (validateField(input.name, formValues[input.name], input)) {
        isError = true;
      };
    })
    return isError;
  }

  const submit = async (e) => {
    e.preventDefault();
    if (checkForm()) return;
    setDisabled(true);
    try {
      await props.onSubmit(formValues)
    } catch(error) {
      setFormErrors({
        ...formErrors,
        [error.inputName]: error.message
      })
    }
  }

  return (
    <form 
      className="base-form-wa__form"
      onSubmit={submit}
    >
      {
        props.formData.map(input => {
          return (
            <div 
              className="base-form-wa__form-group"
              key={input.name}
            >
              <label 
                className="base-form-wa__label" 
                htmlFor={input.name}
              >
                {input.labelName}
              </label>
              {
                input.type !== 'select' &&
                (<input 
                  className={`base-form-wa__input ${formErrors[input.name] ? 'base-form-wa__input--invalid' : ''}`} 
                  id={input.name} 
                  type={input.type} 
                  value={formValues[input.name]} 
                  name={input.name} 
                  onChange={updateField}
                  onBlur={props.readOnly ? null : (e) => validateField(e.target.name, e.target.value, input)}
                  readOnly={input.readOnly}
                />)
              }
              {
                input.type === 'select' &&
                <BaseSelect
                  format="select"
                  value={formValues[input.name]}
                  inputClassName="base-form-wa__select"
                  wrapperClassName="base-form-wa__select-wrapper"
                  id={input.name}
                  name={input.name}
                  selectOptions={input.selectOptions}
                  selectOption={(prop, v) => setFormValues({...formValues, [input.name]: v})}
                />
              }
              {
                formErrors[input.name] &&
                <span className="base-form-wa__error">{formErrors[input.name]}</span>
              }
            </div>
          )
        })  
      }
      <div className="base-form-wa__form-group base-form-wa--wa__form-group">
        <input 
          className="btn btn--primary" 
          type="submit" 
          value={props.buttonName} 
          onSubmit={submit} 
          disabled={disabled}
        />
      </div>
    </form>
  )
}

export default BaseFormWithAction;